import Drawer from '@material-ui/core/Drawer';
import styled from 'styled-components';

import { COLORS } from 'constants/design';

export const DrawerContainer = styled(Drawer)`
  .MuiDrawer-paper {
    overflow-y: visible;
  }
`;

export const DrawerDiv = styled.div`
  width: 375px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .divider {
    width: 375px;
    background: ${COLORS.DEVIDER_GREY};
    height: 2px;
    margin-bottom: 10px;
  }
  .titleConatainer {
    height: 64px;
    padding-left: 24px;
    padding-top: 23px;
    padding-right: 10px;
    display: flex;
    justify-content: space-between;
  }
  .title {
    color: ${COLORS.BLUE};
    text-align: left;
    font-size: 15px;
    font-family: Roboto;
    font-weight: bold;
    letter-spacing: 0px;
    color: #0075c9;
    text-transform: uppercase;
    opacity: 1;
  }
  .actions {
    padding: 10px;
  }

  .action-buttons-container {
    padding: 0 10px;
  }

  .saveButton,
  .cancelButton {
    width: 126px;
    height: 36px;
  }

  .disabledSaveButton {
    width: 126px;
    height: 36px;
    background: #dddddd 0% 0% no-repeat padding-box;
    border: 1px solid #dddddd;
    color: #333e48;
    text-transform: none;
    cursor: not-allowed;
  }
  .rejectButton {
    width: 126px;
    height: 36px;
    margin-top: 5px;
  }
  .disabledRejectButton {
    width: 126px;
    height: 36px;
    background: #dddddd 0% 0% no-repeat padding-box;
    border: 1px solid #dddddd;
    color: #333e48;
    text-transform: none;
    cursor: not-allowed;
  }
  .content {
    overflow-y: scroll;
    height: 100%;
  }
`;
